import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";
import { toast, ToastContainer } from "react-toastify";
import { getPlgSDSPSetpointsBtn } from "../../utils/wellsConfig";
import { ProgressDialog } from "../plungerPage/progressPopup";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

const uint16ToInt16 = (n) => {
  return n > 0x7FFF ? n - 0x10000 : n;
}

const int16ToUint16 = (n) => {
  return n < 0 ? n + 0x10000 : n;
}

const faultGroups = [
  {
    label: "Pressure Faults",
    items: [
      {
        label: "System Volts",
        liveValue: 12.3,
        unit: "VDC",
        setpoints: {
          lolo: "_41051",
          lo: "_41052",
          hi: "_41053",
          hihi: "_41054",
        },
      },
      {
        label: "Field Pressure",
        liveValue: 58.9,
        unit: "PSI",
        setpoints: {
          lolo: "_41055",
          lo: "_41056",
          hi: "_41057",
          hihi: "_41058",
        },
      },
      {
        label: "Interstage Pressure",
        liveValue: 175.0,
        unit: "PSI",
        setpoints: {
          lolo: "_41059",
          lo: "_41060",
          hi: "_41061",
          hihi: "_41062",
        },
      },
      {
        label: "Main Discharge Pressure",
        liveValue: 370.0,
        unit: "PSI",
        setpoints: {
          lolo: "_41063",
          lo: "_41064",
          hi: "_41065",
          hihi: "_41066",
        },
      },
      {
        label: "Suction Scrubber Pressure",
        liveValue: 29.0,
        unit: "PSI",
        setpoints: {
          lolo: "_41071",
          lo: "_41072",
          hi: "_41073",
          hihi: "_41074",
        },
      },
      {
        label: "Compressor Oil Pressure",
        liveValue: 21.0,
        unit: "PSI",
        setpoints: {
          lolo: "_41075",
          lo: "_41076",
          hi: "_41077",
          hihi: "_41078",
        },
      },
      {
        label: "Main Flow Rate",
        liveValue: 183.5,
        unit: "MCF",
        setpoints: {
          lolo: "_41067",
          lo: "_41068",
          hi: "_41069",
          hihi: "_41070",
        },
      },
      {
        label: "Main Motor Amps",
        liveValue: 0,
        unit: "Amps",
        setpoints: { hi: "_41097", hihi: "_41098" },
      },
    ],
  },
  {
    label: "Temperature Faults",
    items: [
      {
        label: "Discharge Temp",
        liveValue: 80.0,
        unit: "°F",
        setpoints: { hi: "_41225", hihi: "_41226" },
      },
      {
        label: "Discharge #2 Temp",
        liveValue: 74.7,
        unit: "°F",
        setpoints: { hi: "_41229", hihi: "_41230" },
      },
      {
        label: "Tail Shaft Temp",
        liveValue: 80.4,
        unit: "°F",
        setpoints: { hi: "_41233", hihi: "_41234" },
      },
      {
        label: "Air Comp Temp",
        liveValue: 80.4,
        unit: "°F",
        setpoints: { hi: "_41237", hihi: "_41238" },
      },
    ],
  },
];
const settings = [
  {
    label: "System Volts",
    liveValue: 12.3,
    unit: "VDC",
    setpoints: {
      lolo: 41051,
      lo: 41052,
      hi: 41053,
      hihi: 41054,
    },
  },
  {
    label: "Field Pressure",
    liveValue: 58.9,
    unit: "PSI",
    setpoints: {
      lolo: 41055,
      lo: 41056,
      hi: 41057,
      hihi: 41058,
    },
  },
  {
    label: "Interstage Pressure",
    unit: "PSI",
    liveValue: 175.0,
    setpoints: {
      lolo: 41059,
      lo: 41060,
      hi: 41061,
      hihi: 41062,
    },
  },
  {
    label: "Main Discharge Pressure",
    unit: "PSI",
    liveValue: 370.0,
    setpoints: {
      lolo: 41063,
      lo: 41064,
      hi: 41065,
      hihi: 41066,
    },
  },
  {
    label: "Suction Scrubber Pressure",
    unit: "PSI",
    liveValue: 29.0,
    setpoints: {
      lolo: 41071,
      lo: 41072,
      hi: 41073,
      hihi: 41074,
    },
  },
  {
    label: "Compressor Oil Pressure",
    unit: "PSI",
    liveValue: 21.0,
    setpoints: {
      lolo: 41075,
      lo: 41076,
      hi: 41077,
      hihi: 41078,
    },
  },
  {
    label: "Main Flow Rate",
    unit: "MCF",
    liveValue: 183.5,
    setpoints: {
      lolo: 41067,
      lo: 41068,
      hi: 41069,
      hihi: 41070,
    },
  },
  {
    label: "Main Motor Amps",
    unit: "Amps",
    liveValue: 0,
    setpoints: {
      hi: 41097,
      hihi: 41098,
    },
  },
  {
    label: "Discharge Temp",
    liveValue: 80.0,
    unit: "°F",
    setpoints: {
      hi: 41225,
      hihi: 41226,
    },
  },
  {
    label: "Discharge #2 Temp",
    liveValue: 74.7,
    unit: "°F",
    setpoints: {
      hi: 41229,
      hihi: 41230,
    },
  },
  {
    label: "Tail Shaft Temp",
    liveValue: 80.4,
    unit: "°F",
    setpoints: {
      hi: 41233,
      hihi: 41234,
    },
  },
  {
    label: "Air Comp Temp",
    liveValue: 80.4,
    unit: "°F",
    setpoints: {
      hi: 41237,
      hihi: 41238,
    },
  },
];
const registers = [
  ...faultGroups.flatMap((group) =>
    group.items.flatMap((item) =>
      item.setpoints ? Object.values(item.setpoints) : [],
    ),
  ),
  "40548",
  "STATE", // added extra register
];

const regListBodyForPCommand = [
  "_41051",
  "_41052",
  "_41053",
  "_41054",
  "_41055",
  "_41056",
  "_41057",
  "_41058",
  "_41059",
  "_41060",
  "_41061",
  "_41062",
  "_41063",
  "_41064",
  "_41065",
  "_41066",
  "_41067",
  "_41068",
  "_41069",
  "_41070",
  "_41071",
  "_41072",
  "_41073",
  "_41074",
  "_41075",
  "_41076",
  "_41077",
  "_41078",
  "_41097",
  "_41098",
  "_41225",
  "_41226",
  "_41229",
  "_41230",
  "_41233",
  "_41234",
  "_41237",
  "_41238",
];

export default function FaultSetpointsC5(selectedDevice) {
  //console.log("Selected Device in FaultSetpoints:", selectedDevice);
  const [loading, setLoading] = useState(true);
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");
  const [data, setData] = useState(null);
  const [engineData, setEngData] = useState(null);
  const [settingsState, setSettingsState] = useState(
    faultGroups.map((group) => ({
      ...group,
      items: group.items.map((item) => ({
        ...item,
        setpoints: item.setpoints
          ? Object.fromEntries(Object.keys(item.setpoints).map((k) => [k, ""]))
          : undefined,
      })),
    })),
  );
  const [pwdDialogOpen, setPwdDialogOpen] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [pendingAction, setPendingAction] = useState(null);
  // Keep the original addresses separately
  const originalAddresses = settings.map((s) => s.setpoints ?? {});

  const fetchData = async () => {
    try {
      setLoading(true);
      const [regResp, engResp] = await Promise.all([
        axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${selectedDevice.selectedDevice.device.id}`,
          registers,
        ),
        axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/engine-data/${selectedDevice.selectedDevice.device.id}`,
        ),
      ]);

      const regData = regResp.data.data.response;
      const engData = engResp.data.response;
      //   console.log("Register Data:", regData);
      //   console.log("Engine Data:", engData);
      const updatedState = faultGroups.map((group) => ({
        ...group,
        items: group.items.map((item) => {
          // Update live value from engine data
          let updatedLiveValue = item.liveValue;
          switch (item.label) {
            case "System Volts":
              updatedLiveValue = engData.SYSTEM_VOTLS;
              break;
            case "Field Pressure":
              updatedLiveValue = engData.FIELD_PRES;
              break;
            case "Interstage Pressure":
              updatedLiveValue = engData.INTERSTAGE_PRES;
              break;
            case "Main Discharge Pressure":
              updatedLiveValue = engData.DISCHARGE_PRES;
              break;
            case "Suction Scrubber Pressure":
              updatedLiveValue = engData.SUCTION_PRES;
              break;
            case "Compressor Oil Pressure":
              updatedLiveValue = engData.COMP_OIL_PRES;
              break;
            case "Main Flow Rate":
              updatedLiveValue = engData.FLOW_METER;
              break;
            case "Main Motor Amps":
              updatedLiveValue = engData.AI11;
              break;
            case "Discharge Temp":
              updatedLiveValue = engData.DISCHARGE_TEMP_FINAL;
              break;
            case "Discharge #2 Temp":
              updatedLiveValue = engData.DISCHARGE_2_TEMP;
              break;
            case "Tail Shaft Temp":
              updatedLiveValue = engData.TAILSHAFT_TEMP;
            case "STATE":
              updatedLiveValue = engData.STATE;
              break;
            case "Air Comp Temp":
              updatedLiveValue = regData[40548];
              break;
          }

          // Update setpoints from register data
          const updatedSetpoints = item.setpoints
            ? Object.fromEntries(
                Object.entries(item.setpoints).map(([k, addr]) => {
                  if (regData[addr] === undefined) return [k, ""];

                  let value = regData[addr];
                  value = uint16ToInt16(value)
                  // Divide by 10 for both Pressure and Temperature Faults, except Main Motor Amps
                  if (
                    (group.label === "Pressure Faults" ||
                      group.label === "Temperature Faults") &&
                    item.label !== "Main Motor Amps"
                  ) {
                    value = value / 10;
                  }

                  return [k, value];
                }),
              )
            : undefined;

          return {
            ...item,
            liveValue: updatedLiveValue,
            setpoints: updatedSetpoints,
          };
        }),
      }));

      setSettingsState(updatedState);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedDevice.selectedDevice?.device?.id) return;
    fetchData();
  }, [selectedDevice.selectedDevice?.device?.id]);

  const handleSetpointChange = (groupIdx, itemIdx, spKey, newValue) => {
    setSettingsState((prev) =>
      prev.map((group, g) =>
        g !== groupIdx
          ? group
          : {
              ...group,
              items: group.items.map((item, i) =>
                i !== itemIdx
                  ? item
                  : {
                      ...item,
                      setpoints: {
                        ...item.setpoints,
                        [spKey]: newValue,
                      },
                    },
              ),
            },
      ),
    );
  };

  const pollForChange = async ({
    unitId,
    registerList,
    lastTime,
    lastResponse,
    durationMs,
    intervalMs,
    onSuccess,
    onTimeout,
  }) => {
    const start = Date.now();

    let pollInterval; // ✅ Declare it here

    const stopPolling = () => {
      if (pollInterval) clearInterval(pollInterval);
    };
    pollInterval = setInterval(async () => {
      try {
        const resp = await axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
          registers,
        );

        const { time: currentTime, response: currentResponse } =
          resp.data.data || {};

        const timeChanged =
          currentTime && Number(currentTime) !== Number(lastTime);

        let valueChanged = false;
        for (const key in currentResponse) {
          if (currentResponse[key] !== lastResponse[key]) {
            valueChanged = true;
            break;
          }
        }

        console.log("⏳ Polling...", {
          currentTime,
          timeChanged,
          valueChanged,
        });

        if (timeChanged && valueChanged) {
          stopPolling();
          onSuccess({
            currentTime,
            currentResponse,
          });
          console.log("🔄 Device time changed:", lastTime, "->", currentTime);
        }

        if (Date.now() - start >= durationMs) {
          stopPolling();
          onTimeout();
        }
      } catch (err) {
        console.warn("Polling error:", err.message);
      }
    }, intervalMs);
  };

  // async function handleUpdatePressureFaults() {
  //   try {
  //     setProgressOpen(true);
  //     setProgressSuccess(false);
  //     const pairs = [];

  //     // Only take the Pressure Faults group (assuming it's the first group)
  //     const pressureGroup = settingsState.find(
  //       (g) => g.label === "Pressure Faults",
  //     );

  //     if (!pressureGroup) {
  //       toast.warning("Pressure Faults group not found");
  //       return;
  //     }

  //     pressureGroup.items.forEach((item, iIdx) => {
  //       if (!item.setpoints) return;

  //       Object.entries(item.setpoints).forEach(([key, value]) => {
  //         if (value === "" || value === null || value === undefined) return;

  //         // Get original register from faultGroups definition
  //         const originalRegister = faultGroups[0].items[iIdx].setpoints[key];

  //         if (!originalRegister) return;

  //         const plcRegister = Number(originalRegister) - 40001;

  //         let finalValue = Number(value);
  //         if (Number.isNaN(finalValue)) return;

  //         // Apply scaling except for Main Motor Amps
  //         if (item.label !== "Main Motor Amps") {
  //           finalValue = Math.round(finalValue * 10);
  //         }

  //         pairs.push({ reg: plcRegister, val: finalValue });
  //       });
  //     });

  //     if (pairs.length === 0) {
  //       toast.warning("No values to update for Pressure Faults");
  //       return;
  //     }

  //     const commandBody = pairs.map((p) => `${p.reg},${p.val}`).join(",");
  //     const cmd = `A,${commandBody}`;
  //     const unitId = selectedDevice.selectedDevice.device.id;

  //     const initialResp = await axios.post(
  //       `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
  //       registers,
  //     );
  //     let lastTime = Number(initialResp.data.data?.time || 0);
  //     let lastResponse = initialResp.data.data?.response || {};
  //     console.log("🚀 Sending Pressure Faults command:", cmd);
  //     await axios.post(
  //       `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
  //       { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,},
  //       {
  //         headers: {
  //           id: "anything",
  //           "Content-Type": "application/json",
  //         },
  //       },
  //     );
  //     // console.log("Sending command:", cmd);
  //     console.log("🟡 Polling for 30s...");
  //     // STEP 3: poll for 30s BEFORE sending P
  //     pollForChange({
  //       unitId,
  //       registers,
  //       lastTime,
  //       lastResponse,
  //       durationMs: 30000,
  //       intervalMs: 4000,

  //       onSuccess: () => {
  //         console.log("✅ Update done after A command");
  //         setProgressSuccess(true);
  //       },

  //       onTimeout: async () => {
  //         console.log("⏰ No change after A, sending P command...");

  //         // === STEP 4: build & send P ===
  //         let pCmd = cmd.replace("A", "P");
  //         pCmd = pCmd.replace(/(-?\d+),\s*(?:-?\d+(?:\.\d+)?|NaN)/gi, "$1,1");
  //         console.log("🚀 Sending P command:", pCmd);
  //         // pCmd += `,${registers.STATE - 40001},1`;

  //         await axios.post(
  //           `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
  //           { unitId, cmd: pCmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${pCmd}`,},
  //           { headers: { id: "anything", "Content-Type": "application/json" } },
  //         );

  //         console.log("🟢 P command sent, polling again...");

  //         // === STEP 5: poll AFTER P ===
  //         pollForChange({
  //           unitId,
  //           registerList,
  //           lastTime,
  //           lastResponse,
  //           durationMs: 170000,
  //           intervalMs: 4000,

  //           onSuccess: () => {
  //             console.log("✅ Update done after P command");
  //             setProgressSuccess(true);
  //           },

  //           onTimeout: () => {
  //             console.warn("❌ Timeout after P command");
  //             setProgressError(
  //               "⏰ Timeout waiting for device response. Please try again.",
  //             );
  //           },
  //         });
  //       },
  //     });
  //   } catch (err) {
  //     console.error(err);
  //     setProgressError("Failed to update.");
  //     setProgressOpen(false);
  //   }
  // }

  // async function handleUpdateTemperatureFaults() {
  //   try {
  //     // Step 1: Open dialog
  //     setProgressOpen(true);
  //     setProgressSuccess(false);

  //     const pairs = [];

  //     // Take the Temperature Faults group
  //     const tempGroup = settingsState.find(
  //       (g) => g.label === "Temperature Faults",
  //     );
  //     if (!tempGroup) {
  //       toast.warning("Temperature Faults group not found");
  //       return;
  //     }

  //     tempGroup.items.forEach((item, iIdx) => {
  //       if (!item.setpoints) return;

  //       Object.entries(item.setpoints).forEach(([key, value]) => {
  //         if (value === "" || value === null || value === undefined) return;

  //         const originalRegister = faultGroups[1].items[iIdx].setpoints[key];
  //         if (!originalRegister) return;

  //         const plcRegister = Number(originalRegister) - 40001;

  //         let finalValue = Number(value);
  //         if (Number.isNaN(finalValue)) return;

  //         // Use raw value or apply scaling if PLC requires (Pressure faults multiply by 10)
  //         pairs.push({ reg: plcRegister, val: finalValue * 10 });
  //       });
  //     });

  //     if (pairs.length === 0) {
  //       toast.warning("No values to update for Temperature Faults");
  //       return;
  //     }

  //     const commandBody = pairs.map((p) => `${p.reg},${p.val}`).join(",");
  //     const cmd = `A,${commandBody}`;
  //     const unitId = selectedDevice.selectedDevice.device.id;

  //     console.log("🚀 Sending Temperature Faults A command:", cmd);

  //     const initialResp = await axios.post(
  //       `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
  //       registers,
  //     );

  //     let lastTime = Number(initialResp.data.data?.time || 0);
  //     let lastResponse = initialResp.data.data?.response || {};

  //     // Send A command
  //     await axios.post(
  //       `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
  //       { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,},
  //       { headers: { id: "anything", "Content-Type": "application/json" } },
  //     );

  //     console.log("🟡 Polling for 30s...");
  //     pollForChange({
  //       unitId,
  //       registers,
  //       lastTime,
  //       lastResponse,
  //       durationMs: 30000,
  //       intervalMs: 4000,

  //       onSuccess: () => {
  //         console.log("✅ Update done after A command");
  //         setProgressSuccess(true);
  //       },

  //       onTimeout: async () => {
  //         console.log("⏰ No change after A, sending P command...");

  //         // Build & send P command
  //         let pCmd = cmd.replace("A", "P");
  //         // Set all values to 1 (like Pressure Faults flow)
  //         pCmd = pCmd.replace(/(-?\d+),\s*(?:-?\d+(?:\.\d+)?|NaN)/gi, "$1,1");
  //         console.log("🚀 Sending P command:", pCmd);
  //         //  pCmd += `,${registers.STATE - 40001},1`;

  //         await axios.post(
  //           `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
  //           { unitId, cmd: pCmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${pCmd}`,},
  //           { headers: { id: "anything", "Content-Type": "application/json" } },
  //         );

  //         console.log("🟢 P command sent, polling again...");

  //         pollForChange({
  //           unitId,
  //           registerList: registers,
  //           lastTime,
  //           lastResponse,
  //           durationMs: 170000,
  //           intervalMs: 4000,

  //           onSuccess: () => {
  //             console.log("✅ Update done after P command");
  //             setProgressSuccess(true);
  //           },

  //           onTimeout: () => {
  //             console.warn("❌ Timeout after P command");
  //             setProgressError(
  //               "⏰ Timeout waiting for device response. Please try again.",
  //             );
  //           },
  //         });
  //       },
  //     });
  //   } catch (err) {
  //     console.error(err);
  //     setProgressError("Failed to update.");
  //     setProgressOpen(false);
  //   }
  // }

  async function doUpdateSingleItem(groupLabel, item, itemIndex) {
    try {
      // const correctPwd = "PRC2103";

      // const enteredPwd = window.prompt(
      //   "Enter password to apply setpoint changes:",
      // );

      // if (enteredPwd === null) {
      //   // user cancelled
      //   setProgressOpen(false);
      //   return;
      // }

      // if (enteredPwd !== correctPwd) {
      //   toast.error("❌ Incorrect password");
      //   setProgressOpen(false);
      //   return;
      // }
      setProgressOpen(true);
      setProgressSuccess(false);
      setProgressError("");

      const pairs = [];

      // Find group index in faultGroups
      const groupIndex = faultGroups.findIndex((g) => g.label === groupLabel);
      if (groupIndex === -1) {
        toast.error("Group not found");
        return;
      }

      const originalItem = faultGroups[groupIndex].items[itemIndex];

      Object.entries(item.setpoints || {}).forEach(([key, value]) => {
        if (value === "" || value === null || value === undefined) return;

        const originalRegister = originalItem.setpoints[key];
        if (!originalRegister) return;

        const cleanRegister = String(originalRegister).replace("_", "");
        const plcRegister = Number(cleanRegister) - 40001;

        let finalValue = Number(value);
        if (Number.isNaN(finalValue)) return;

        // SCALE: multiply by 10 for everything except Main Motor Amps
        if (item.label !== "Main Motor Amps") {
          finalValue = Math.round(finalValue * 10);
        }

        finalValue = int16ToUint16(finalValue)
        
        pairs.push({ reg: plcRegister, val: finalValue });
      });

      if (pairs.length === 0) {
        toast.warning("No values to update for this item");
        setProgressOpen(false);
        return;
      }

      const commandBody = pairs.map((p) => `${p.reg},${p.val}`).join(",");
      const cmd = `S,${commandBody}`;
      const unitId = selectedDevice.selectedDevice.device.id;

      console.log("🚀 Sending S command:", cmd);

      // Get initial snapshot
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        registers,
      );

      let lastTime = Number(initialResp.data.data?.time || 0);
      let lastResponse = initialResp.data.data?.response || {};

      // Send A command
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
        { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,},
        { headers: { id: "anything", "Content-Type": "application/json" } },
      );

      // Poll
      pollForChange({
        unitId,
        registers,
        lastTime,
        lastResponse,
        durationMs: 30000,
        intervalMs: 4000,

        onSuccess: () => {
          console.log("✅ Update done after A");
          setProgressSuccess(true);
        },

        onTimeout: async () => {
          console.log("⏰ No change, sending P...");

          let pCmd = cmd.replace("S", "P");
          pCmd = pCmd.replace(/(-?\d+),\s*(?:-?\d+(?:\.\d+)?|NaN)/gi, "$1,1");

          console.log("🚀 Sending P command:", pCmd);

          await axios.post(
            `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
            { unitId, cmd: pCmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${pCmd}`,},
            { headers: { id: "anything", "Content-Type": "application/json" } },
          );

          pollForChange({
            unitId,
            registerList: registers,
            lastTime,
            lastResponse,
            durationMs: 170000,
            intervalMs: 4000,

            onSuccess: () => {
              console.log("✅ Update done after P");
              setProgressSuccess(true);
            },

            onTimeout: () => {
              console.warn("❌ Timeout");
              setProgressError("⏰ Timeout waiting for device response.");
            },
          });
        },
      });
    } catch (err) {
      console.error(err);
      setProgressError("Failed to update.");
    }
  }

  function handleUpdateSingleItem(groupLabel, item, itemIndex) {
    // Instead of running directly, open password dialog
    setPendingAction(
      () => () => doUpdateSingleItem(groupLabel, item, itemIndex),
    );
    setPwdDialogOpen(true);
  }

  return (
    <Box sx={{ width: "100%", maxWidth: "100vw" }}>
      <Box
        sx={{
          bgcolor: "#1e293b",
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography sx={{ color: "#ffffffff", fontSize: 14 }}>
          Fault Setpoints
        </Typography>

        {/* Right side buttons */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            justifyContent: "flex-end",
            flexGrow: 1,
          }}
        >
          <Button
            color="primary"
            variant="contained"
            size="small"
            sx={{ fontSize: 12 }}
            onClick={() =>
              getPlgSDSPSetpointsBtn(
                selectedDevice.selectedDevice?.device?.id,
                regListBodyForPCommand,
                "P,1050,28,1096,2,1224,2,1228,2,1232,2,1236,2",
                setProgressSuccess,
                setProgressError,
                setProgressOpen,
              )
            }
          >
            Get Setpoints
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: "#374151",
          color: "#fff",
          py: 3,
          px: 2,
          width: "100%",
        }}
      >
        {loading ? (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              bgcolor: "rgba(187, 183, 183, 0.12)",
              backdropFilter: "blur(5px)",
              zIndex: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress color="#60a5fa" size={70} />
          </Box>
        ) : (
          settingsState.map((group, gIdx) => (
            <Box key={gIdx} sx={{ mb: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  bgcolor: "#1f2937",
                  px: 2,
                  py: 1,
                  borderRadius: 1,
                  mb: 1,
                  borderLeft: "4px solid #8fdcffff",
                }}
              >
                <Typography
                  sx={{ color: "#fff", fontSize: 16, fontWeight: 700 }}
                >
                  {group.label}
                </Typography>

                {/* Buttons for this group */}
              </Box>

              {group.items.map((item, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      md: "minmax(200px, 1fr) minmax(120px, 150px) repeat(4, minmax(100px, 1fr)) 100px",
                    },
                    gap: 2,
                    alignItems: "center",
                    borderBottom: "1px solid #a0a0a0ff",
                    py: 1.5,
                  }}
                >
                  <Typography
                    sx={{ color: "#fff", fontWeight: 600, fontSize: 13 }}
                  >
                    {item.label}
                  </Typography>
                  <Typography sx={{ color: "#78c2dbff", fontSize: 13 }}>
                    {item.liveValue} {item.unit}
                  </Typography>

                  {["lolo", "lo", "hi", "hihi"].map((spKey) => (
                    <Box key={spKey}>
                      {item.setpoints?.[spKey] !== undefined ? (
                        <TextField
                          label={spKey.toUpperCase()}
                          size="small"
                          value={item.setpoints[spKey]}
                          fullWidth
                          // type="number"
                          onChange={(e) =>
                            handleSetpointChange(
                              gIdx,
                              idx,
                              spKey,
                              e.target.value,
                            )
                          }
                          InputLabelProps={{
                            style: { color: "#fff", fontSize: 14 },
                          }}
                          InputProps={{
                            sx: {
                              color: "#fff",
                              backgroundColor: "#1f2937",
                              padding: 0.2,
                              fontSize: 12,
                            },
                          }}
                        />
                      ) : (
                        <Box sx={{ height: "40px" }} />
                      )}
                    </Box>
                  ))}
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ fontSize: 12, height: 36 }}
                    onClick={() =>
                      handleUpdateSingleItem(group.label, item, idx)
                    }
                  >
                    Update
                  </Button>
                </Box>
              ))}
            </Box>
          ))
        )}
      </Box>
      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await fetchData();
        }}
        loadingMessage="Check Device Response. Operation in-progress ..."
        successMessage="Successfully updated!"
      />
      <Dialog open={pwdDialogOpen} onClose={() => setPwdDialogOpen(false)}>
        <DialogTitle>Update Setpoints</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter password to apply setpoint changes.
          </DialogContentText>

          <TextField
            autoFocus
            margin="dense"
            label="Password"
            type="password"
            fullWidth
            variant="outlined"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setPwdDialogOpen(false);
              setPasswordInput("");
              setPendingAction(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              const correctPwd = "PRC2103"; // or from env

              if (passwordInput !== correctPwd) {
                toast.error("❌ Incorrect password");
                return;
              }

              // close dialog
              setPwdDialogOpen(false);
              setPasswordInput("");

              // run pending action
              if (pendingAction) pendingAction();

              setPendingAction(null);
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
